export const InterceptorSkipHeader = 'X-Skip-Interceptor';
export const CmsUrl = 'https://media.nuernberger.digital';
export const siegelUrl = 'https://nuernberger.digital/_Resources/Persistent';
export const AvbUrlRlv = 'https://media.nuernberger.digital/pdf/AVB_Risikolebensversicherung_Digital.pdf';
export const AvbUrlDkr = 'https://media.nuernberger.digital/pdf/AVB_Krebsversicherung_Digital_202201.pdf';
